module.exports = __webpack_public_path__ + "static/media/tushar.d8c19a3a.png";